var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemotecom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200.000000pt",
    height: "1200.000000pt",
    viewBox: "0 0 1200.000000 1200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6000 l0 -6000 6000 0 6000 0 0 6000 0 6000 -6000 0 -6000 0 0 -6000z m6383 3191 c519 -92 964 -319 1318 -672 448 -448 694 -1041 688 -1664 -4 -432 -110 -814 -328 -1181 -183 -309 -488 -617 -796 -805 l-83 -51 14 -40 c45 -127 133 -253 228 -325 141 -106 314 -159 616 -187 30 -3 121 -6 203 -6 l147 0 0 -740 0 -741 -237 2 c-276 2 -380 10 -593 45 -1146 190 -1871 921 -1985 2004 -11 96 -15 263 -15 580 l0 445 318 79 c370 92 456 121 557 186 221 145 354 374 371 640 32 488 -366 893 -851 867 -136 -8 -204 -25 -320 -83 -207 -102 -355 -281 -427 -514 l-23 -75 -3 -1682 -2 -1683 -790 0 -790 0 1 1733 c1 1870 0 1809 55 2055 154 686 614 1268 1254 1586 268 133 521 209 820 245 133 17 519 6 653 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemotecom);
export default __webpack_public_path__ + "static/media/remote.com.e1d329013fcdc25ce5abe274c4cda532.svg";
export { ForwardRef as ReactComponent };